import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';

// COMPONENTS
import { ColorPickerModule } from 'ngx-color-picker';

import { FeatureModule } from 'v2/shared/feature/feature.module';
import { DumbFiltersComponent } from 'v2/standalone/dumb-filters/dumb-filters.component';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { AppIntegrationAccountModule } from '../app-integration-account/app-integration-account.module';
import { ClientShippingAddressAccessorComponent } from '../client/components/client-shipping-address-accessor/client-shipping-address-accessor.component';
import { ClientProfileModule } from '../client-profile/client-profile.module';
import { OrderModule } from '../order/order.module';
import { RfqModule } from '../rfq/rfq.module';
import { OrderAgTableOrderLineItemsComponent } from '../shared/components/order-ag-table-order-line-items/order-ag-table-order-line-items.component';
import { DirectiveModule } from '../shared/directives/directive.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { SharedModule } from '../shared/shared.module';
import { ShippingModule } from '../shipping/shipping.module';
import { UiModule } from '../ui/ui.module';

import { ChannelModule } from './../channel/channel.module';
import { CompanyModule } from './../company/company.module';
import {
  SalesOrderAgTableComponent,
  SalesOrderComponent,
  SalesOrderStatusTabComponent,
  SalesOrderCustomFieldCellRendererComponent,
  SalesOrderTagCellRendererComponent,
  SalesOrderBulkActionComponent,
  SalesOrderDropdownActionCellRendererComponent,
  SalesOrderUpdateStatusFormComponent,
  SalesOrderCustomFieldCellEditorComponent,
  SalesOrderSidebarComponent,
  SalesOrderTextColumnCellEditorComponent,
  SalesOrderPicklistStatusCellRendererComponent,
  SalesOrderRecipientFormComponent,
  SalesOrderOrderIdCellRendererComponent,
  SalesOrderGroupColumnComponent,
  SalesOrderSidebarBulkUpdateComponent,
  SalesOrderOrderStatusCellRendererComponentComponent,
  SalesOrderClickableCellRendererComponent,
  SalesOrderManagePresetsComponent,
  SalesOrderFormComponent,
  SalesOrderPicklistConfirmActionComponent,
  SalesOrderInvoiceIdsCellRendererComponent,
} from './components';
import { SalesOrderAgTableLineItemsComponent } from './components/sales-order-ag-table-line-items/sales-order-ag-table-line-items.component';
import { CreateInvoiceFromSalesOrderFormComponent } from './components/sales-order-invoicing';
import { SalesOrderLineItemsPurchaseOrderDialogComponent } from './components/sales-order-line-items-purchase-order-dialog/sales-order-line-items-purchase-order-dialog.component';
import { SalesOrderShipmentStatusCellRendererComponent } from './components/sales-order-shipment-status-cell-renderer/sales-order-shipment-status-cell-renderer.component';

// MODULES

import { CanEditSalesOrderItemsPipe } from './pipes/can-edit-sales-order-items';
import { CanEditSalesOrderPipe } from './pipes/can-edit-sales-order.pipe';
import { OrderItemsAgTablePipe } from './pipes/order-items-ag-table.pipe';
import { OrderStatusLabel } from './pipes/order-status-label.pipe';

// Services

// Pipes

const components = [
  SalesOrderAgTableComponent,
  SalesOrderComponent,
  SalesOrderStatusTabComponent,
  SalesOrderCustomFieldCellRendererComponent,
  SalesOrderTagCellRendererComponent,
  SalesOrderBulkActionComponent,
  SalesOrderDropdownActionCellRendererComponent,
  SalesOrderUpdateStatusFormComponent,
  SalesOrderCustomFieldCellEditorComponent,
  SalesOrderSidebarComponent,
  SalesOrderTextColumnCellEditorComponent,
  SalesOrderPicklistStatusCellRendererComponent,
  SalesOrderRecipientFormComponent,
  SalesOrderOrderIdCellRendererComponent,
  SalesOrderGroupColumnComponent,
  SalesOrderSidebarBulkUpdateComponent,
  SalesOrderOrderStatusCellRendererComponentComponent,
  SalesOrderClickableCellRendererComponent,
  SalesOrderManagePresetsComponent,
  SalesOrderFormComponent,
  SalesOrderPicklistConfirmActionComponent,
  SalesOrderInvoiceIdsCellRendererComponent,
];

const angularModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
];

const lumModules = [
  ClientProfileModule,
  SharedComponentsModule,
  PipeModule,
  MaterialCustomModule,
  UiModule,
  DirectiveModule,
  OrderModule,
  ShippingModule,
  ChannelModule,
  AppIntegrationAccountModule,
  SharedModule,
  FeatureModule,
  RfqModule,
  CompanyModule,
];

const libModules = [AgGridModule, ColorPickerModule];

const pipes = [OrderItemsAgTablePipe, OrderStatusLabel];
const standalonePipes = [CanEditSalesOrderPipe, CanEditSalesOrderItemsPipe];
const standaloneComponents = [
  ClientShippingAddressAccessorComponent,
  DumbFiltersComponent,
  SalesOrderShipmentStatusCellRendererComponent,
  SalesOrderAgTableLineItemsComponent,
  OrderAgTableOrderLineItemsComponent,
  SalesOrderLineItemsPurchaseOrderDialogComponent,
  CreateInvoiceFromSalesOrderFormComponent,
];

@NgModule({
  declarations: [...components, ...pipes],
  exports: [...components],
  imports: [
    ...angularModules,
    ...lumModules,
    ...libModules,
    ...standalonePipes,
    ...standaloneComponents,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SalesOrderModule {}
